import { ScaleResult } from "app/shared/models/scale-result";
import { ChartColor } from "app/assessment-charts/models/chart-color";

export class ScaleResultColorService  {

    private _bgColorsForRangeSize:Map<number, ChartColor[]>;
    private readonly PURPLE = "rgba(102,51,204, 1)";
    private readonly LIGHT_BLUE = "rgba(92,141,181, 1)";
    private readonly GREEN = "rgba(102,153,51, 1)";
    private readonly ORANGE = "rgba(204,102,0, 1)";
    private readonly RED = "rgba(204,0,0, 1)";
    
    constructor() {
        this._bgColorsForRangeSize = new Map<number, ChartColor[]>();
        this._bgColorsForRangeSize.set(1, this.getSingleRange());
        this._bgColorsForRangeSize.set(2, this.getTwoRange());
        this._bgColorsForRangeSize.set(3, this.getThreeRange());
        this._bgColorsForRangeSize.set(4, this.getFourRange());
        this._bgColorsForRangeSize.set(5, this.getFiveRange());
    }

    private getSingleRange() {
        let color = this.LIGHT_BLUE;
        let singleColor = new ChartColor("Score", color);
        return [singleColor];
    }

    private getTwoRange() {
        let low = new ChartColor("Low", "rgb(208, 253, 72)");
        let high = new ChartColor("Severe", "rgb(253, 71, 47)");
        return [low, high];
    }

    private getThreeRange() {
        let low = new ChartColor("Low", "rgb(208, 253, 72)");
        let moderate = new ChartColor("Moderate", "rgb(231, 162, 60)");
        let high = new ChartColor("Severe", "rgb(253, 71, 47)");
        return [low, moderate, high];
    }

    private getFourRange() {
        let low = new ChartColor("Low", "rgb(208, 253, 72)");
        let lowModerate = new ChartColor("Low-Moderate", "rgb(219, 208, 66)");
        let moderateHigh = new ChartColor("Moderate-Severe", "rgb(242, 117, 53)");
        let high = new ChartColor("Severe", "rgb(253, 71, 47)");
        return [low, lowModerate, moderateHigh, high];
    }

    private getFiveRange() {
        let low = new ChartColor("Low", "rgb(208, 253, 72)");
        let lowModerate = new ChartColor("Low-Moderate", "rgb(219, 208, 66)");
        let moderate = new ChartColor("Moderate", "rgb(231, 162, 60)");
        let moderateHigh = new ChartColor("Moderate-Severe", "rgb(242, 117, 53)");
        let high = new ChartColor("Severe", "rgb(253, 71, 47)");
        return [low, lowModerate, moderate, moderateHigh, high];
    }


    public getBackgroundColors(scaleRangeLength:number) : ChartColor[] {
        let colors:ChartColor[];
        switch (scaleRangeLength) {
            case 1:
                colors = this.getSingleRange();
                break;
            case 2:
                colors = this.getTwoRange();
                break;
            case 3:
                colors = this.getThreeRange();
                break;
            case 4: 
                colors = this.getFourRange();
                break;
            case 5: 
                colors = this.getFiveRange();
                break;
            case 7:
                colors = [
                    new ChartColor("Tier 1", "rgb(48, 48, 253)")
                    ,new ChartColor("Tier 2", "rgb(48, 150, 253)")
                    ,new ChartColor("Tier 3", "rgb(48, 253, 202)")
                    ,new ChartColor("Tier 4", "rgb(48, 253, 48)")
                    ,new ChartColor("Tier 5", "rgb(253, 253, 48)")
                    ,new ChartColor("Tier 6", "rgb(253, 150, 48)")
                    ,new ChartColor("Tier 7", "rgb(253, 71, 47)")
                ];
                break;
            default:
                colors = [];

                // for (var i = 0; i < scaleRangeLength; i++) {
                //     let initialColor = this.getSingleRange();
                //     colors.push(initialColor[0]);
                // }
                // break;
        }
        return colors;
    }

    private getBackgroundColorForRange(scaleRangeLength:number, rangeIndex:number) {
        let chartColors = this.getBackgroundColors(scaleRangeLength);
        if (rangeIndex >= 0 && rangeIndex < chartColors.length) {
            return chartColors[rangeIndex];
        }
        // return the first one.
        return chartColors[0];
    }

    public getBackgroundColorForScaleResult(scaleResult:ScaleResult) {
        let rangeLength = 1;
        let rangeIndex = 0;
        if (scaleResult.range && scaleResult.scale 
            && scaleResult.scale.ranges 
            && scaleResult.scale.ranges.length) {
            let ranges = scaleResult.scale.ranges;
            rangeLength = ranges.length;
            rangeIndex = scaleResult.scale.ranges.findIndex(r => r.id == scaleResult.range.id);
        }
        return this.getBackgroundColorForRange(rangeLength, rangeIndex);
    }

}


// WEBPACK FOOTER //
// ./src/app/assessment-charts/services/scale-result-color.service.ts